const CreatorCard: React.FC<any> = ({ children }) => {
  return <div className="card shadow-sm m-1 p-5">{children}</div>;
};

export default CreatorCard;
